import React, { useState } from "react";
import "./styles.scss";
import "./mobile.scss";
import { Button, InputBox, TextArea } from "../../../components";
import { withRouter } from "react-router-dom";
import { getLanguage } from "../../../utils/environment";
import { CheckValidity } from "../../../utils/formValidity";
import { sendFeedback } from "../../moreInfo/contactUs/service/contact.service";
import { Store } from "react-notifications-component";

const Index = (props) => {
  const len = getLanguage();

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = React.useState({
    firstName: {
      key: "firstName",
      label: "First name",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "How we call you",
      },
      validation: {
        required: true,
      },
      touched: false,
      isValid: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    mobileNo: {
      key: "mobileNo",
      label: "Mobile number",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "76 822 2201",
      },
      validation: {
        required: true,
      },
      touched: false,
      isValid: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    email: {
      key: "email",
      label: "Working email address",
      size: "lg",
      isShowRequired: true,
      elementConfig: {
        type: "text",
        placeholder: "Enter you working email address",
      },
      validation: {
        required: true,
        email: true,
      },
      touched: false,
      isValid: false,
      isLoading: false,
      invalidReason: "",
      value: "",
      isRequired: true,
    },
    message: {
      key: "message",
      label: "Message",
      size: "lg",
      elementConfig: {
        type: "text",
        placeholder: "Write a message here",
      },
      touched: false,
      validation: {
        required: true,
      },
      isValid: false,
      invalidReason: "",
      value: "",
    },
  });

  const handleChange = async (event, inputIdentity) => {
    const updateContactForm = {
      ...formData,
    };

    updateContactForm[inputIdentity].value = event;

    let validityRes = await CheckValidity(
      inputIdentity,
      updateContactForm[inputIdentity].value,
      updateContactForm[inputIdentity].validation,
      updateContactForm.firstName.value,
      updateContactForm.mobileNo.value,
      updateContactForm.email.value
    );
    console.log(updateContactForm.firstName.value);
    if (validityRes) {
      updateContactForm[inputIdentity].isValid = validityRes.isValid;
      updateContactForm[inputIdentity].invalidReason = validityRes.reason;
      updateContactForm[inputIdentity].touched = true;
      // updateContactForm[inputIdentity] = updatedFormElement;
      let formIsValid = false;
      for (let inputIdentifier in updateContactForm) {
        formIsValid = updateContactForm[inputIdentifier].valid && formIsValid;
      }

      setFormData(updateContactForm);
    }
  };

  const clearAll = () => {
    const updateNewsForm = {
      ...formData,
    };
    for (let key in updateNewsForm) {
      console.log(updateNewsForm[key]);
      updateNewsForm[key].value = "";
      updateNewsForm[key].isValid = false;
      updateNewsForm[key].touched = false;
    }
    setFormData(updateNewsForm);
  };

  const onClickSendFeedback = async () => {
    setIsLoading(true);

    const updateCategoryForm = {
      ...formData,
    };

    const response = await sendFeedback({
      firstName: updateCategoryForm.firstName.value,
      mobileNo: updateCategoryForm.mobileNo.value,
      email: updateCategoryForm.email.value,
      message: updateCategoryForm.message.value,
    });
    console.log("category details ===", response);
    try {
      if (response.data) {
        Store.addNotification({
          title: "Success!",
          message: "Feedback Sent Successfully!",
          type: "success",
          insert: "top",
          container: "top-right",
          dismiss: { duration: 3000, onScreen: true },
        });
        setIsLoading(false);
        clearAll();
      }
    } catch (error) {
      Store.addNotification({
        title: "Error!",
        message: "Feedback sending Failed!",
        type: "danger",
        insert: "top",
        container: "top-right",
        dismiss: {
          duration: 3000,
          onScreen: true,
        },
      });
      setIsLoading(false);
    }
  };

  const updateContactForm = { ...formData };

  return (
    <div className={"contact-form"}>
      <InputBox
        data={updateContactForm.firstName}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateContactForm.firstName.key);
        }}
      />
      <InputBox
        data={updateContactForm.mobileNo}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateContactForm.mobileNo.key);
        }}
      />
      <InputBox
        data={updateContactForm.email}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateContactForm.email.key);
        }}
      />
      <TextArea
        data={updateContactForm.message}
        onChange={async (e) => {
          e.preventDefault();
          await handleChange(e.target.value, updateContactForm.message.key);
        }}
      />
      <Button
        data={{
          mainLayerStyles: "mt-3",
          btnName: "Done",
          buttonType:
            updateContactForm.firstName.value === "" ||
            updateContactForm.mobileNo.value === "" ||
            updateContactForm.email.value === "" ||
            updateContactForm.message.value === ""
              ? "primary disabled"
              : "primary",
          buttonSize: "lg",
          isLoading: isLoading,
          disable:
            updateContactForm.firstName.value === "" ||
            updateContactForm.mobileNo.value === "" ||
            updateContactForm.email.value === "" ||
            updateContactForm.message.value === ""
              ? true
              : false,
        }}
        onClick={async (e) => {
          e.preventDefault();
          await onClickSendFeedback(e);
        }}
      />
    </div>
  );
};

export default withRouter(Index);
